const requirementsActionTypes = {
    ADD_REQUIREMENT: 'ADD_REQUIREMENT',
    DELETE_ITEM_REQUIREMENTS: 'DELETE_ITEM_REQUIREMENTS',
    DELETE_REQUIREMENT: 'DELETE_REQUIREMENT',
    EDIT_REQUIREMENT_COMPLETED: 'EDIT_REQUIREMENT_COMPLETED',
    EDIT_REQUIREMENT_TEXT: 'EDIT_REQUIREMENT_TEXT',
    SET_REQUIREMENTS: 'SET_REQUIREMENTS'
};

export default requirementsActionTypes;